<template>
  <span>
    <span v-if="delta">
      <span v-if="value > 0" class="arrow positive">&#9650; </span>
      <span v-else-if="value < 0" class="arrow negative">&#9660; </span>
      <span v-else class="zero">-</span>
    </span>
    <span
      v-if="!(delta && Math.abs(value) <= 0)"
      :style="{ color: textColorStyle }"
    >
      <span
        :class="{
          zero: !value || value == 0,
          not_delta: !delta,
          positive: value > 0,
          negative: value < 0,
        }"
        >{{ total.toLocaleString().trim() }}%<span v-if="!delta && !emptyVal"
          >%</span
        >
      </span>
    </span>
  </span>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    color: { type: Boolean, default: false },
    value: { type: [String, Number], default: 0 },
    // Turn given value into a percentage (eg *100)
    format: { type: Boolean, default: false },
    rounding: { type: Number, default: 2 },
    delta: { type: Boolean, default: false },
    emptyVal: { type: Boolean, default: false },
  },
  computed: {
    total() {
      if (this.format) {
        const total = (parseFloat(this.value) || 0) * 100
        if (Math.abs(total) < 1 && total !== 0) {
          // If number is a fraction, use toPrecision
          return Math.abs(total).toPrecision(1)
        }
        // else round
        return _.round(Math.abs(total), this.rounding)
      } else {
        return this.value
      }
    },
    textColorStyle() {
      if (!this.color) {
        return ''
      }

      if (this.value > 0) {
        return '#04aa33'
      } else if (this.value < 0) {
        return '#d20000'
      } else {
        return ''
      }
    },
  },
}
</script>
<style scoped>
.zero {
  color: var(--color-subtle);
}
.positive {
  color: var(--color-text-positive);
}

.not_delta.positive::before {
  content: '+';
}

.negative {
  color: var(--color-text-negative);
}

.not_delta.negative::before {
  content: '-';
}
</style>
